import type { ParseRule } from './types';

export const INVOICE_PARSE_RULE: ParseRule = {
  columnMapping: {
    Tipo: 'type',
    Folio: 'folio',
    RUT: 'stakeholderIdentifier',
    'Rut deudor': 'stakeholderIdentifier',
    'RUT/Rut deudor': 'stakeholderIdentifier',
    Fecha: 'issuedDate',
    'Fecha Recepcion': 'issuedDate',
    'Fecha/Fecha Recepcion': 'issuedDate',
    Monto: 'amount',
    'Monto total': 'amount',
    'Monto/Monto total': 'amount',
    'Razon Social': 'stakeholderName',
    Vencimiento: 'dueDate',
    Codigo: 'type',
  },
  dateFields: ['issuedDate', 'dueDate'],
  amountFields: ['amount'],
  codeToType: {
    column: 'Codigo',
    map: {
      '33': 'electronic-invoice',
      '34': 'electronic-invoice-exempt',
      '46': 'electronic-invoice-buyer',
    },
  },
  requiredKeysForRow: ['folio', 'stakeholderIdentifier', 'type'],
};

export const CHECK_PARSE_RULE: ParseRule = {
  columnMapping: {
    Folio: 'folio',
    RUT: 'stakeholderIdentifier',
    Fecha: 'issuedDate',
    Monto: 'amount',
    'Razón social': 'stakeholderName',
    'Razon social': 'stakeholderName',
    BusinessName: 'businessName',
    Vencimiento: 'dueDate',
  },
  dateFields: ['issuedDate', 'dueDate'],
  amountFields: ['amount'],
  requiredKeysForRow: ['folio', 'stakeholderIdentifier'],
};

export const DOCUMENT_PARSE_RULE: ParseRule = {
  columnMapping: {
    Folio: 'folio',
    RUT: 'stakeholderIdentifier',
    Fecha: 'issuedDate',
    Monto: 'amount',
  },
  dateFields: ['issuedDate'],
  amountFields: ['amount'],
  requiredKeysForRow: ['folio', 'stakeholderIdentifier'],
};

export const RENEGOTIATION_PARSE_RULE: ParseRule = {
  columnMapping: {
    Folio: 'folio',
    Fecha: 'issuedDate',
    Monto: 'amount',
    RUT: 'stakeholderIdentifier',
    Vencimiento: 'dueDate',
  },
  dateFields: ['issuedDate', 'dueDate'],
  amountFields: ['amount'],
  requiredKeysForRow: ['folio', 'stakeholderIdentifier'],
};
